module.exports = __webpack_public_path__ + "b74f74eb58c9298a66b2c5b5250083f6.png";